/**
 * This barrel file provides the export for the lazy loaded AboutComponent.
 */
 export * from './home.component';
export * from './home.route';
export * from './home.module';
